<template>
  <div>
    <div class="bg-hero mb-5">
      <section id="welcome__section" class="welcome__section container mx-auto">
        <div class="welcome__section--intro">
          <h1 class="welcome__section--text" v-html="welcomeMessage"></h1>
          <h1>{{ name }}</h1>
          <div class="desc">
            <p>
              <span class="marker">{{ title1 }}</span>
            </p>
          </div>
        </div>
        <lottie-player
          src="https://assets5.lottiefiles.com/packages/lf20_u5nd9awf.json"
          background="transparent"
          speed="1"
          style="width: 300px; height: 300px;"
          loop
          autoplay
        ></lottie-player>
        <a href="#skills">
          <div id="arrow-down"></div>
        </a>
      </section>
    </div>

    <Skills />
    <MyServices />
  </div>
</template>

<script>
import Skills from "@/components/Skills.vue";
import MyServices from "@/components/MyServices.vue";

export default {
  name: "Index",
  components: {
    Skills,
    MyServices
  },
  data() {
    return {
      name: "I'm Mohamed Sabry",
      title1: "Software Developer",
      welcomeMessage: "Welcome to my <span class='marker'>Portfolio</span>"
    };
  }
};
</script>

<style lang="scss">
@import "../assets/css/_variables.scss";

.bg-hero {
  // clip-path: polygon(0 0, 100% 0, 100% 80%, 0 100%);
  clip-path: polygon(0% 0%, 0% 87%, 50% 100%, 100% 87%, 100% 0%);
  // background-color: #d7eff1;
  background-image: linear-gradient(
    115deg,
    rgba(188, 233, 216, 0.8),
    rgba(138, 138, 208, 0.7)
  );
}

.welcome__section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 100vh;
  letter-spacing: 0.75px;

  &--intro {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  &--text {
    font-size: 65.3%;
  }

  @media all and (max-width: 480px) {
    min-height: 60vh;
  }

  h1 {
    font-size: 3rem;
  }

  .desc {
    font-size: 2rem;
  }

  h1,
  h2 {
    @media all and (max-width: 480px) {
      font-size: 3.2rem;
    }
  }

  &--text {
    font-size: 3.5rem;
    margin-bottom: 3rem;

    @media all and (min-width: 480px) {
      font-size: 3.2rem;
    }
  }

  @media all and (max-width: 720px) {
    lottie-player {
      display: none;
    }
  }

  i {
    font-size: 4rem;
    text-shadow: 0 0 4px #fff;

    @media all and (min-width: 480px) {
      font-size: 3rem;
    }
  }

  #arrow-down {
    position: absolute;
    left: 50%;
    bottom: 40px;
    width: 26px;
    height: 26px;
    text-align: center;
    margin-left: -13px;
    z-index: 1000;
    border: solid #f8f9fa;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
    animation: animatedArrow 2s infinite;

    @media all and (max-width: 480px) {
      display: none;
    }
  }

  @keyframes animatedArrow {
    0% {
      bottom: 40px;
    }

    30% {
      bottom: 25px;
      border-color: $third-color;
    }

    100% {
      bottom: 40px;
    }
  }
}

.marker {
  background-image: linear-gradient(
    transparent 0%,
    transparent calc(50% - 9px),
    rgba(0, 255, 0, 0.35) calc(50% - 9px),
    rgba(0, 255, 0, 0.35) 100%
  );
  transition: all 120ms ease-in-out 0s;
  background-size: 100% 200%;
  background-position: 0 0;
  word-break: break-word;

  &:hover {
    background-image: linear-gradient(
      transparent 0%,
      transparent calc(50% - 9px),
      rgb(0, 255, 0) calc(50% - 9px),
      rgb(0, 255, 0) 100%
    );
    background-position: 0 100%;
  }
}

.desktop-hidden {
  @media all and (min-width: 720px) {
    display: none;
  }
}

.mobile-hidden {
  @media all and (max-width: 720px) {
    display: none;
  }
}

.block {
  display: block;
}
</style>
